import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyRegistryGuest = loadable(() => import(/* webpackChunkName: "content/registry-guest" */ './GuestRegistry'), 'GuestRegistryProvider');
